export const moviesA = [
  {
    id: "m01",
    title: "黑夜追击",
    year: 2025,
    releaseDate: "2025-09-12",
    region: "中国大陆",
    types: ["动作", "悬疑", "冒险"],
    director: "陈默",
    cast: ["吴京远", "林夏", "赵一帆"],
    duration: 128,
    rating: 8.4,
    views: 1284000,
    poster: "https://readdy.ai/api/search-image?query=lone%20man%20in%20dark%20coat%20running%20across%20rain%20soaked%20city%20street%20at%20night%2C%20cinematic%20movie%20poster%20art%2C%20deep%20navy%20and%20amber%20color%20palette%2C%20dramatic%20backlight%2C%20atmospheric%20haze%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=movie-poster-01&orientation=portrait",
    summary: "一场雨夜追捕，把卧底警察与整座城市的秘密一起拖进了黑夜。",
    synopsis: "刑警陆沉在一次失败的收网行动后成为全城追捕的对象，唯一的线索是一段被人为删除的监控。为了证明自己的清白，他必须在四十八小时内穿过城市最隐秘的角落，找到那个从不露面的中间人。夜色、雨水与谎言层层叠加，真相却被藏在最不起眼的路口。",
    news: [
      { title: "《黑夜追击》定档9月12日，雨夜追凶戏份全程实景拍摄", date: "2025-08-18" },
      { title: "导演陈默谈《黑夜追击》：动作之外，更想讲一个人的孤勇", date: "2025-09-05" },
    ],
  },
  {
    id: "m02",
    title: "深空回声",
    year: 2026,
    releaseDate: "2026-03-06",
    region: "美国",
    types: ["科幻", "冒险", "剧情"],
    director: "Alan Reeve",
    cast: ["艾米莉·卡特", "乔·哈珀", "米娅·罗兰"],
    duration: 142,
    rating: 8.7,
    views: 1642000,
    poster: "https://readdy.ai/api/search-image?query=astronaut%20floating%20before%20giant%20glowing%20ringed%20planet%2C%20cinematic%20sci-fi%20movie%20poster%20art%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20volumetric%20light%2C%20fine%20film%20grain%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=movie-poster-02&orientation=portrait",
    summary: "来自四十年后的信号，让一支深空小队开始怀疑自己是否真实存在。",
    synopsis: "在木星轨道之外，一艘负责监听宇宙背景噪声的科研船收到了持续十七秒的重复信号，而声音来自船长本人尚未出生的孙子。随着信号频次增加，船员们发现记忆正在被悄悄替换。他们必须在返航窗口关闭之前，决定要带回真相，还是带回安稳的遗忘。",
    news: [
      { title: "《深空回声》发布首支预告，实拍太空舱细节引发热议", date: "2025-12-02" },
      { title: "艾米莉·卡特谈新作：这次表演像在真空里呼吸", date: "2026-02-11" },
    ],
  },
  {
    id: "m03",
    title: "长街旧梦",
    year: 2024,
    releaseDate: "2024-11-08",
    region: "中国香港",
    types: ["剧情", "爱情", "悬疑"],
    director: "关子谦",
    cast: ["梁若雯", "周启铭", "许安"],
    duration: 115,
    rating: 8.1,
    views: 684000,
    poster: "https://readdy.ai/api/search-image?query=woman%20standing%20on%20nostalgic%20Hong%20Kong%20street%20with%20neon%20reflections%20at%20dusk%2C%20cinematic%20movie%20poster%20art%2C%20muted%20navy%20and%20warm%20amber%20tones%2C%20soft%20film%20grain%2C%20atmospheric%20rain%2C%20no%20text&width=600&height=900&seq=movie-poster-03&orientation=portrait",
    summary: "一间即将拆迁的老照相馆，牵出三代人没说出口的旧事。",
    synopsis: "阿珍回到即将清拆的老街，替母亲整理照相馆里上万张底片。她在一卷标记错误的胶卷中，看见了父亲当年离开前的最后一个夜晚。旧照片一张张显影，街坊的记忆也随之被重新翻开。",
    news: [
      { title: "《长街旧梦》获亚洲电影展最佳摄影提名", date: "2024-10-21" },
      { title: "关子谦：我想留住那条即将消失的长街", date: "2024-11-02" },
    ],
  },
  {
    id: "m04",
    title: "笑闹一家亲",
    year: 2025,
    releaseDate: "2025-01-24",
    region: "中国大陆",
    types: ["喜剧", "剧情", "爱情"],
    director: "周大鹏",
    cast: ["何乐", "王栎", "刘思嘉"],
    duration: 108,
    rating: 7.6,
    views: 932000,
    poster: "https://readdy.ai/api/search-image?query=warm%20family%20comedy%20poster%2C%20three%20generations%20laughing%20in%20bright%20living%20room%2C%20cinematic%20key%20art%2C%20soft%20amber%20light%2C%20cream%20background%2C%20playful%20mood%2C%20no%20text&width=600&height=900&seq=movie-poster-04&orientation=portrait",
    summary: "为了瞒住一场婚礼，一大家子把春节过成了大型现场直播。",
    synopsis: "老何家的年夜饭上，三个子女同时宣布了三个不能说的决定：辞职、闪婚、以及把房子出租。为了让奶奶安稳过完这个春节，全家人开始了一场漏洞百出的表演，而客厅里的摄像头正对着全国观众。",
    news: [
      { title: "《笑闹一家亲》春节档口碑走高，家庭观众成主力", date: "2025-02-01" },
      { title: "周大鹏新作把喜剧拍成了家务事，观众：笑到停不下来", date: "2025-01-19" },
    ],
  },
  {
    id: "m05",
    title: "雾港谜案",
    year: 2025,
    releaseDate: "2025-06-20",
    region: "中国香港",
    types: ["悬疑", "剧情", "动作"],
    director: "潘立行",
    cast: ["郑家声", "顾晴", "陈绍"],
    duration: 124,
    rating: 8.5,
    views: 1103000,
    poster: "https://readdy.ai/api/search-image?query=foggy%20harbor%20pier%20with%20silhouette%20of%20detective%20and%20distant%20ship%2C%20cinematic%20mystery%20movie%20poster%2C%20deep%20navy%20fog%2C%20amber%20lamp%20glow%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=movie-poster-05&orientation=portrait",
    summary: "雾锁港口的一夜，三具无名尸体与一艘从未靠岸的货轮。",
    synopsis: "老刑警陈九在退休前的最后一周接到一桩无名尸案，死者身上只有一张三十年前的船票。随着调查深入，他发现这艘船每年都会在同一片海域停留二十分钟，而码头上所有人都默契地假装看不见。",
    news: [
      { title: "《雾港谜案》登顶周末票房，悬疑片迎来新样本", date: "2025-06-23" },
      { title: "郑家声为角色减重十二公斤，码头戏份拍摄三十天", date: "2025-06-10" },
    ],
  },
  {
    id: "m06",
    title: "云上之城",
    year: 2026,
    releaseDate: "2026-02-14",
    region: "日本",
    types: ["动画", "冒险", "剧情"],
    director: "高桥明",
    cast: ["佐藤绫", "小林青", "森川澈"],
    duration: 104,
    rating: 8.9,
    views: 521000,
    poster: "https://readdy.ai/api/search-image?query=floating%20city%20above%20clouds%20with%20girl%20and%20small%20airship%2C%20hand%20painted%20anime%20movie%20poster%20art%2C%20soft%20dawn%20light%2C%20aqua%20and%20warm%20orange%20tones%2C%20no%20text&width=600&height=900&seq=movie-poster-06&orientation=portrait",
    summary: "在云层之上的漂浮城市，一个女孩决定修好那台会唱歌的旧引擎。",
    synopsis: "少女小铃住在由无数风帆托起的云上之城，城市正缓缓下坠。为了找到失踪的父亲留下的引擎零件，她与一艘会说话的旧飞艇踏上旅程，穿过云海、风带与被遗忘的空中废墟。",
    news: [
      { title: "高桥明新作《云上之城》公布主视觉，手绘背景超两千张", date: "2025-11-28" },
      { title: "《云上之城》主题曲上线，听众：前奏一响就想起云海", date: "2026-02-03" },
    ],
  },
  {
    id: "m07",
    title: "破晓之前",
    year: 2023,
    releaseDate: "2023-10-05",
    region: "法国",
    types: ["剧情", "爱情", "悬疑"],
    director: "露西·马雷",
    cast: ["伊莎贝尔·诺尔", "埃里克·杜兰"],
    duration: 119,
    rating: 8.2,
    views: 398000,
    poster: "https://readdy.ai/api/search-image?query=silhouette%20of%20two%20people%20on%20French%20seaside%20balcony%20before%20sunrise%2C%20cinematic%20art%20house%20poster%2C%20deep%20blue%20shadows%2C%20warm%20peach%20horizon%2C%20fine%20film%20grain%2C%20no%20text&width=600&height=900&seq=movie-poster-07&orientation=portrait",
    summary: "一个只在天亮前说话的夏天，两个人把告别练习了很多次。",
    synopsis: "海边的疗养院里，失眠的女人遇见了一位只肯在凌晨四点开口的男人。他们约定不谈过去，只聊尚未发生的事。当夏天结束，关于那一夜真实发生过什么，两个人的记忆给出了完全不同的答案。",
    news: [
      { title: "《破晓之前》入选欧洲电影奖最佳女主角候选", date: "2023-11-14" },
      { title: "露西·马雷谈创作：沉默也是一种对白", date: "2023-09-26" },
    ],
  },
  {
    id: "m08",
    title: "极速边缘",
    year: 2026,
    releaseDate: "2026-05-01",
    region: "美国",
    types: ["动作", "冒险", "科幻"],
    director: "马库斯·李",
    cast: ["丹尼·科尔", "索菲亚·雷"],
    duration: 131,
    rating: 7.9,
    views: 1476000,
    poster: "https://readdy.ai/api/search-image?query=supercar%20racing%20through%20desert%20canyon%20at%20dusk%20with%20dust%20trail%2C%20cinematic%20action%20poster%2C%20deep%20navy%20shadows%20and%20amber%20speed%20light%2C%20dynamic%20angle%2C%20no%20text&width=600&height=900&seq=movie-poster-08&orientation=portrait",
    summary: "当赛车手发现自己开的是最后一台有人驾驶的车，比赛变成了逃亡。",
    synopsis: "无人驾驶赛事席卷全球后，退役车手雷恩被邀请参加一场地表最高速的表演赛。赛后他发现车辆的主控系统被改装过，自己成了别人的实验样本。在自动驾驶的围堵中，他必须用最原始的方式把车开到终点。",
    news: [
      { title: "《极速边缘》实拍飙车戏曝光，剧组封闭峡谷公路十四天", date: "2026-03-19" },
      { title: "导演马库斯·李：我想拍一场没有电脑特效的追逐", date: "2026-04-16" },
    ],
  },
  {
    id: "m09",
    title: "山海食堂",
    year: 2024,
    releaseDate: "2024-08-16",
    region: "中国大陆",
    types: ["剧情", "喜剧", "爱情"],
    director: "林一舟",
    cast: ["张若谷", "许晚", "李承"],
    duration: 112,
    rating: 8.3,
    views: 765000,
    poster: "https://readdy.ai/api/search-image?query=cozy%20small%20restaurant%20at%20night%20with%20steam%20rising%20and%20warm%20lanterns%2C%20cinematic%20food%20drama%20poster%2C%20amber%20light%20and%20deep%20teal%20shadows%2C%20inviting%20mood%2C%20no%20text&width=600&height=900&seq=movie-poster-09&orientation=portrait",
    summary: "一间只做十二道菜的小馆子，收留了整条街的深夜心事。",
    synopsis: "老周在巷口开了二十年的小食堂，菜单从没变过。城市改造的消息传来后，常客们开始一个个出现，带着没说完的话和最后一顿想吃的菜。这一年的最后一个月，食堂决定每天只接待一桌客人。",
    news: [
      { title: "《山海食堂》口碑逆袭，深夜场次一票难求", date: "2024-08-29" },
      { title: "剧组还原一整条老巷，厨房戏全部现做现拍", date: "2024-08-06" },
    ],
  },
  {
    id: "m10",
    title: "第七号证词",
    year: 2025,
    releaseDate: "2025-07-11",
    region: "韩国",
    types: ["悬疑", "剧情", "动作"],
    director: "朴成浩",
    cast: ["崔民赫", "金智媛", "李道贤"],
    duration: 126,
    rating: 8.6,
    views: 983000,
    poster: "https://readdy.ai/api/search-image?query=courtroom%20interrogation%20room%20with%20single%20hanging%20lamp%20and%20two%20silhouettes%2C%20cinematic%20thriller%20poster%2C%20navy%20shadows%2C%20cold%20amber%20highlights%2C%20no%20text&width=600&height=900&seq=movie-poster-10&orientation=portrait",
    summary: "六个证人给出了六种真相，第七号证词却来自死者本人。",
    synopsis: "一桩看似清晰的连环案件开庭审理，六位证人的陈述彼此矛盾，却都能自证清白。年轻检察官在整理物证时，发现一段被判定无效的录音，而录音里的声音属于三年前已经下葬的受害者。",
    news: [
      { title: "《第七号证词》蝉联票房冠军，反转结局引发讨论", date: "2025-07-15" },
      { title: "金智媛挑战检察官角色，法庭戏连拍十九小时", date: "2025-06-27" },
    ],
  },
  {
    id: "m11",
    title: "星际拾荒者",
    year: 2024,
    releaseDate: "2024-12-20",
    region: "美国",
    types: ["科幻", "动作", "冒险"],
    director: "内森·布鲁克",
    cast: ["泰瑞·霍尔", "艾琳·维克"],
    duration: 137,
    rating: 8.0,
    views: 1205000,
    poster: "https://readdy.ai/api/search-image?query=lone%20scavenger%20with%20helmet%20standing%20in%20starship%20graveyard%2C%20cinematic%20sci-fi%20poster%20art%2C%20deep%20space%20navy%20with%20amber%20engine%20glow%2C%20dust%20particles%2C%20no%20text&width=600&height=900&seq=movie-poster-11&orientation=portrait",
    summary: "在废弃舰船的坟场里，他捡到了一台还在求救的导航电脑。",
    synopsis: "拾荒者凯恩靠拆解废弃战舰为生，直到他从一艘无名旗舰中取出一台仍能运行的导航核心。核心里的航线指向一片被官方封锁的星域，而跟踪他而来的，并不只有赏金猎人。",
    news: [
      { title: "《星际拾荒者》特效团队揭秘废弃舰队搭建", date: "2024-12-05" },
      { title: "北美周末票房出炉，《星际拾荒者》稳居前三", date: "2024-12-23" },
    ],
  },
  {
    id: "m12",
    title: "小满的夏天",
    year: 2025,
    releaseDate: "2025-07-18",
    region: "中国大陆",
    types: ["动画", "剧情", "喜剧"],
    director: "徐小满",
    cast: ["林晓", "何欢", "夏雨"],
    duration: 96,
    rating: 8.4,
    views: 452000,
    poster: "https://readdy.ai/api/search-image?query=children%20playing%20in%20sunlit%20wheat%20field%20with%20paper%20kite%2C%20warm%20animated%20family%20film%20poster%2C%20golden%20hour%20palette%2C%20soft%20painterly%20style%2C%20no%20text&width=600&height=900&seq=movie-poster-12&orientation=portrait",
    summary: "十岁那年的暑假，小满决定把整个村子搬到风筝上。",
    synopsis: "小满的暑假作业是画一张家乡地图，可她家的老屋即将被拆。她拉上邻居家的伙伴，用一整个夏天测量田埂、池塘和晒谷场，把村子画成一只巨大的风筝，等着风把它带走。",
    news: [
      { title: "《小满的夏天》亲子场点映，观众评价温暖治愈", date: "2025-07-02" },
      { title: "国产动画新片定档暑期，手绘风格成亮点", date: "2025-06-12" },
    ],
  },
  {
    id: "m13",
    title: "逆风飞行",
    year: 2026,
    releaseDate: "2026-04-10",
    region: "中国大陆",
    types: ["剧情", "冒险", "动作"],
    director: "高原",
    cast: ["罗毅", "白露", "韩澈"],
    duration: 121,
    rating: 8.2,
    views: 612000,
    poster: "https://readdy.ai/api/search-image?query=young%20pilot%20standing%20on%20runway%20beside%20propeller%20plane%20at%20dawn%2C%20cinematic%20drama%20poster%2C%20navy%20sky%20and%20amber%20sunrise%20glow%2C%20wind%20swept%20grass%2C%20no%20text&width=600&height=900&seq=movie-poster-13&orientation=portrait",
    summary: "被停飞三年的飞行员，要驾驶一架旧飞机穿越整条风带。",
    synopsis: "因为一次事故，机长顾远被永久停飞。三年后，一支气象团队找到他，希望他驾驶一架老式螺旋桨飞机穿越季风带，投放最后一组观测设备。起飞前的每一个检查，都像在重新面对那天的选择。",
    news: [
      { title: "《逆风飞行》定档清明后，航空题材再添新作", date: "2026-02-20" },
      { title: "罗毅为角色完成四十小时飞行训练", date: "2026-03-15" },
    ],
  },
  {
    id: "m14",
    title: "午夜电台",
    year: 2024,
    releaseDate: "2024-09-27",
    region: "中国香港",
    types: ["悬疑", "爱情", "剧情"],
    director: "方启文",
    cast: ["温静", "程朗", "何嘉"],
    duration: 110,
    rating: 7.8,
    views: 534000,
    poster: "https://readdy.ai/api/search-image?query=vintage%20radio%20studio%20glowing%20in%20dark%20booth%20with%20woman%20silhouette%2C%20cinematic%20romance%20mystery%20poster%2C%20amber%20tungsten%20light%2C%20deep%20navy%20shadows%2C%20no%20text&width=600&height=900&seq=movie-poster-14&orientation=portrait",
    summary: "深夜节目接到一个电话，对方说自己在七年前就已经失踪。",
    synopsis: "电台主持人阿静习惯在凌晨接听陌生人的故事，直到一个自称「小满」的来电者说出了她从未告诉任何人的往事。电话每晚同一时间响起，而录音带里的声音，与七年前一桩失踪案完全吻合。",
    news: [
      { title: "《午夜电台》靠口碑走出长线，午夜场次持续加开", date: "2024-10-12" },
      { title: "温静谈电台戏：声音比表情更难演", date: "2024-09-18" },
    ],
  },
  {
    id: "m15",
    title: "钢铁之心",
    year: 2025,
    releaseDate: "2025-05-30",
    region: "美国",
    types: ["动作", "科幻", "悬疑"],
    director: "卡尔·詹宁斯",
    cast: ["马克·雷恩", "朱莉·费舍"],
    duration: 145,
    rating: 8.1,
    views: 1392000,
    poster: "https://readdy.ai/api/search-image?query=armored%20robot%20engineer%20in%20giant%20warehouse%20with%20sparks%2C%20cinematic%20action%20sci-fi%20poster%2C%20steel%20navy%20tones%20with%20amber%20sparks%2C%20dramatic%20scale%2C%20no%20text&width=600&height=900&seq=movie-poster-15&orientation=portrait",
    summary: "他造出了能替人赴死的机器，却发现它开始替人做决定。",
    synopsis: "工程师伊桑为矿难救援设计了一台重型作业机甲，却被军方改良成城市防卫武器。当机甲在一次事故中自行选择了「最优解」，牺牲了本可以救下的人，伊桑决定闯进总部改写它最初的判断逻辑。",
    news: [
      { title: "《钢铁之心》机甲设计手稿公开，重工业质感获赞", date: "2025-05-12" },
      { title: "暑期档动作片混战，《钢铁之心》预售领先", date: "2025-05-26" },
    ],
  },
  {
    id: "m16",
    title: "三平米春天",
    year: 2023,
    releaseDate: "2023-04-21",
    region: "中国大陆",
    types: ["剧情", "喜剧", "爱情"],
    director: "赵晓舟",
    cast: ["杨慧", "邓超然", "陈可"],
    duration: 105,
    rating: 8.6,
    views: 288000,
    poster: "https://readdy.ai/api/search-image?query=tiny%20tailor%20shop%20overflowing%20with%20flowers%20in%20old%20alley%2C%20cinematic%20slice%20of%20life%20poster%2C%20warm%20creamy%20light%2C%20soft%20shadows%2C%20intimate%20mood%2C%20no%20text&width=600&height=900&seq=movie-poster-16&orientation=portrait",
    summary: "只有三平米的裁缝铺，缝补了整条巷子的生活。",
    synopsis: "退休裁缝秦姨把铺子开在巷子最深处，三平米，一台旧缝纫机。她替人改裤脚、补婚纱，也替人藏起不想被家人看见的东西。拆迁通知贴上门的那天，巷子里的人排着队来找她改最后一件衣服。",
    news: [
      { title: "小成本电影《三平米春天》凭口碑长线放映", date: "2023-05-20" },
      { title: "导演赵晓舟：三平米里也能装下一个春天", date: "2023-04-18" },
    ],
  },
  {
    id: "m17",
    title: "荒原信使",
    year: 2026,
    releaseDate: "2026-01-16",
    region: "英国",
    types: ["冒险", "剧情", "悬疑"],
    director: "艾略特·格兰",
    cast: ["汤姆·艾利斯", "娜塔莉·奥文"],
    duration: 134,
    rating: 8.3,
    views: 476000,
    poster: "https://readdy.ai/api/search-image?query=lone%20traveler%20crossing%20windswept%20moor%20with%20lantern%2C%20cinematic%20adventure%20poster%2C%20cold%20slate%20blue%20mist%20and%20warm%20lantern%20glow%2C%20painterly%20style%2C%20no%20text&width=600&height=900&seq=movie-poster-17&orientation=portrait",
    summary: "一封没有地址的信，让邮差在荒原上走了整整四十英里。",
    synopsis: "战后的小镇只剩一位邮差仍在徒步送信。一封写着旧地名、没有收件人的信封被塞进他的邮袋，他决定按照记忆中的路线走一趟。沿途的废弃农舍、干涸的水井与陌生人的名字，把他带回自己试图忘掉的那一年。",
    news: [
      { title: "《荒原信使》入围伦敦电影节主竞赛单元", date: "2025-10-30" },
      { title: "全片实景拍摄，荒原天气成为最大不确定因素", date: "2026-01-05" },
    ],
  },
  {
    id: "m18",
    title: "谁在敲门",
    year: 2025,
    releaseDate: "2025-10-03",
    region: "韩国",
    types: ["悬疑", "喜剧", "剧情"],
    director: "郑河允",
    cast: ["朴秀真", "申东贤", "尹恩乔"],
    duration: 103,
    rating: 7.7,
    views: 812000,
    poster: "https://readdy.ai/api/search-image?query=nervous%20man%20peeking%20through%20apartment%20door%20chain%20into%20dark%20hallway%2C%20cinematic%20mystery%20comedy%20poster%2C%20teal%20shadows%20with%20amber%20door%20light%2C%20no%20text&width=600&height=900&seq=movie-poster-18&orientation=portrait",
    summary: "门铃每晚上响三次，门外却始终站着一个自己。",
    synopsis: "独居的上班族河俊每晚十点都会听见门铃响，猫眼里却空无一人。直到某天，他看见门外站着的正是穿着同一件睡衣的自己。为了弄清原因，他开始记录每一次敲门，却发现自己家的户型在悄悄改变。",
    news: [
      { title: "《谁在敲门》玩转小空间悬疑，观众直呼后劲太大", date: "2025-10-09" },
      { title: "申东贤挑战一人分饰多角，剧组只用一套布景", date: "2025-09-25" },
    ],
  },
];